import { API_BASE_URL } from "../../constant/constant";
import React, { useEffect, useState } from "react";
import Email from "../../assets/Email.svg";
import EmailedFailed from "../../assets/cross-icon.svg";
import StatusDisplay from "../../Components/StatusDisplay/StatusDisplay";
import { useNavigate, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";

const VerificationSuccess = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const [loading, setLoading] = useState(true);
  const [verificationSuccess, setVerificationSuccess] = useState(null);

  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/verify-email`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        });

        if (response.ok) {
          setVerificationSuccess(true);
        } else {
          setVerificationSuccess(false);
        }
      } catch (error) {
        setVerificationSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [token]);

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleSignUpClick = () => {
    navigate("/signup");
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <StatusDisplay
      imgSrc={verificationSuccess ? Email : EmailedFailed}
      title={verificationSuccess ? t("auth.verificationPages.success.title") : t("auth.verificationPages.failure.title")}
      handleClick={verificationSuccess ? handleLoginClick : handleSignUpClick}
      text={verificationSuccess ? t("auth.verificationPages.success.text") : t("auth.verificationPages.failure.text")}
      btnText={verificationSuccess ? t("auth.verificationPages.success.button") : t("auth.verificationPages.failure.button")}
    />
  );
};

export default VerificationSuccess;
